import { Empty } from "antd";
import CollapseItemComponent from "../collapse-item";
import { TTelegramBotDialogueRow } from "@lib/types/TelegramChatBot";

interface CollapseItemsProps {
  data?: TTelegramBotDialogueRow[];
  parentIndex?: number;
  refetchDialogue?: () => void;
  requireAuth?: boolean;
}

const CollapseItems = ({
  data,
  parentIndex = 1,
  refetchDialogue,
  requireAuth,
}: CollapseItemsProps) => {
  if (!data?.length) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
  }

  return (
    <>
      {data.map((item) => (
        <CollapseItemComponent
          key={item.id}
          parentIndex={parentIndex}
          item={item}
          refetchDialogue={refetchDialogue}
          requireAuth={requireAuth}
        />
      ))}
    </>
  );
};

export default CollapseItems;
